export function pluralizeRu(
    count: number,
    one: string,
    few: string,
    many: string
): string {
    const absoluteCount = Math.abs(count);
    const mod100 = absoluteCount % 100;
    const mod10 = absoluteCount % 10;

    if (mod100 >= 11 && mod100 <= 14) {
        return many;
    }

    if (mod10 === 1) {
        return one;
    }

    if (mod10 >= 2 && mod10 <= 4) {
        return few;
    }

    return many;
}
